var path = '/opt/atlassian/pipelines/agent/build/src/app/common/libs/image-crop/image-crop.html';
var html = "<div class=modal-body> <ui-cropper class=full-width canvas-scalemode=full-width result-image=$ctrl.croppedImage image=\"$ctrl.resolve.details.image | ngfDataUrl\" area-type={{$ctrl.resolve.details.config.areaType}} aspect-ratio=$ctrl.resolve.details.config.aspectRatio result-image-size=$ctrl.resolve.details.config.resultImageSize></ui-cropper> </div> <div class=modal-footer> <button ng-click=$ctrl.resolve.details.onCancel() class=btn-cancel> cancel </button> <button ng-click=$ctrl.resolve.details.onCrop($ctrl.croppedImage) class=btn-ok> crop </button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/libs/image-crop/image-crop.html
// module id = 934
// module chunks = 0